import { auth } from "lib/firebase.config";

const withAuthentication = async <T,>(fn: (idToken: string) => Promise<T>) => {
  const token = await auth.currentUser?.getIdToken();
  if (token == null) throw new Error("Unauthorized");

  return fn(token);
};

export default withAuthentication;
